import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize, shareReplay, timeout } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { SKIP_TENANT_AUTH_REFRESH } from '../../interceptors/auth-refresh-context';

@Injectable({
  providedIn: 'root',
})
export class TenantSessionRefreshService {
  private readonly http = inject(HttpClient);
  private refreshInFlight$: Observable<unknown> | null = null;

  refresh(): Observable<unknown> {
    if (!this.refreshInFlight$) {
      this.refreshInFlight$ = this.http.post(`${environment.apiGatewayUrl}/api/v1/user/refresh`, {}, {
        context: new HttpContext().set(SKIP_TENANT_AUTH_REFRESH, true),
        responseType: 'text',
        withCredentials: true,
      }).pipe(
        timeout(8000),
        finalize(() => {
          this.refreshInFlight$ = null;
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }

    return this.refreshInFlight$;
  }
}
